<template>
    <container :class="{
      'pa-0': $vuetify.breakpoint.smAndDown,
      'px-0 py-0': $vuetify.breakpoint.mdAndUp,
    }">
    
      

    <v-layout justify-space-around>   
        <v-flex xs12 sm10>       
            <v-img :src='require("../../../assets/static/img/img-Blog/Post-1.webp")' alt="imagen principal del articulo"></v-img>   
        </v-flex>  
    </v-layout>

        <v-layout align-center justify-center row wrap>
                <v-flex class="articulo" justify-center sm10>
                <h1>Salvoconducto de Mudanzas</h1>
                <br>
                <h2>En simple</h2>

                <p>Mucha gente se pregunta ¿porque me piden un Salvoconducto de Mudanzas?
                En principio parece ser un tramite latero, difícil y sin justificación, pero la tiene…</p>

                <br>
                <p>Es para respaldar que tienes los permisos necesarios para realizar la mudanza y que nada 
                lo impide.</p>

                <br>
                <p>El o la propietaria del lugar que dejas certifica que las cuentas están al día y que la 
                propiedad se encuentra en buenas condiciones o al menos de la misma forma en que la 
                recibiste. También es posible tengan un acuerdo distinto que es necesario dejar en claro, 
                por ejemplo una ampliación o cambio estructural que se haya realizado de mutuo 
                acuerdo. Si todo está en regla podrás realizar el trámite. Es barato y demora muy poco</p>    
                <br>    
                
                <h2>¿Que necesitas?</h2>
                <br>
                <h3><i>Si la propiedad es tuya</i></h3>
                <p>En este caso es mucho mas fácil, son menos los papeles que necesitas.</p>
                <ul>
                    <li> Cedula de Identidad</li>
                    <li> Certificado de dominio Vigente o  Pago e Contribuciones</li>
                    <li> Nombre del conductor, RUT y patente del vehículo que hará la mudanza </li>      
                </ul> 

                <h3><i>Si arriendas</i></h3>   
                <p>Acá necesitas mas información, pero nada del otro mundo</p>
                <ul>
                    <li> Carta del o la propietaria autorizando la salida </li>
                    <li> Copa de la cedula de identidad del o la propietaria </li>
                    <li> Contrato de Arriendo original</li>
                    <li> Cedula de identidad del o la arrendataria </li>
                    <li> Comprobante de pago de luz, agua, gas y gastos comunes (si corresponde) </li>
                    <li> Nombre del conductor, RUT y patente del vehículo que hará la mudanza   </li>              
                </ul> 
                <br>
                <h2>¿Donde lo Consigues?</h2>
                <br>
                <p>Por ley el salvoconducto debe ser emitido en una notaria de la comuna de origen, es decir 
                donde comienza la mudanza. En caso de que no exista puedes emitirlo en una notaria que 
                esté en la comuna de destino. Esta es una de esas reglas “raras”, pero la ley es la ley…</p>
                <br>
                <p>Por suerte hoy en día también es posible generar el documento a través de algunas 
                plataformas online como <strong><i>MuySimple</i></strong> o <strong><i>NotarioExpress.</i></strong> Esta pareciera ser la opción ideal 
                para todos… pero no!!! Hay muchas personas que prefieren ir a la notaria, hacer la fila, 
                preguntar lo que ya sabe y que le den un papel firmado J. También están todos los y las 
                amigas senior que no se manejan digitalmente y para ellos es mas fácil pasar por el 
                mesón.</p>         
                <br>
                <h2>Ojo con...</h2>
                <p>Siempre necesitaras :</p>
                <ul>
                    <li> Nombre y RUT del conductor que realizará la mudanza y la Patente del vehículo. </li>
                    <li> Si el edificio no cuenta con estacionamiento para camiones y es necesario dejar el 
                        vehículo en la calle, será necesario pedir un <strong>Permiso de municipal</strong> de estacionamiento en 
                        la vía pública. Sería solo una piedra mas en el camino… nada es imposible.</li>
                </ul> 
                <br>
                <p><h3>Copyright © DuoApp 2022</h3></p>
                <br>
                <v-btn @click="retroceder()" style="background-color: #1f97b9; color: #ffffff;">volver</v-btn>
               
                </v-flex>
        </v-layout>        
    </container>
</template>
<script>
import { EventBus } from "../../../events.js";
export default {
    data () {
        return{
        }
    },
    methods: {

        retroceder(){
        EventBus.$emit('Retroceder', 1);
      }
    },
    mounted(){
        window.scrollTo(0, 0)
    }

}
</script>
    